import { render } from "./boatTransport.vue?vue&type=template&id=15e43e2e&scoped=true"
import script from "./boatTransport.vue?vue&type=script&lang=js"
export * from "./boatTransport.vue?vue&type=script&lang=js"

import "./boatTransport.vue?vue&type=style&index=0&id=15e43e2e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e43e2e"]])

export default __exports__